import { render, staticRenderFns } from "./ReceiptPage.vue?vue&type=template&id=76cf7427&scoped=true&"
import script from "./ReceiptPage.vue?vue&type=script&lang=js&"
export * from "./ReceiptPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76cf7427",
  null
  
)

export default component.exports